export default "__VITE_ASSET__CxeAUGwt__"